"use client";
import { Stack, Typography, Box } from "@mui/material";

import { useStore } from "../../../../service/mobx";
import ButtonText from "../../../../component/Button/Text";
import { dialogFeedback } from "../../../../component/Dialog/dialogs/appWide/Feedback";

export default function Footer({ paper }) {
  const { dialog } = useStore();

  return (
    <Box mt={2}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        py={1}
        px={2}
      >
        <Typography
          variant="bodySm"
          color="var(--secondary-color)"
          sx={{ textWrap: "balance" }}
        >
          <Box
            component="a"
            target="_blank"
            typography="labelMd"
            fontWeight={700}
            href="https://bytez.com"
            color="var(--primary-color)"
            sx={{ textDecoration: "none" }}
          >
            Bytez.com
          </Box>{" "}
          - Designed for Accessibility and to further Open Science
        </Typography>
        <ButtonText
          size="small"
          label="Send feedback"
          onClick={() => dialog.configure(dialogFeedback)}
        />
      </Stack>
      {paper?.publisher === "arxiv" ? <License paper={paper} /> : null}
    </Box>
  );
}
const License = ({ paper }) => (
  <Typography
    component="p"
    px={2}
    variant="labelSm"
    color="var(--secondary-color)"
    pb={{ compact: 8, expanded: 2 }}
  >
    Thank you {paper.authorArray?.join(", ") ?? ""}, who authored {paper.title}{" "}
    🙏 This page is the html of their{" "}
    <a href={`https://arxiv.org/abs/${paper.paperID}`} target="_blank">
      arXiv
    </a>{" "}
    <a href={`https://arxiv.org/pdf/${paper.paperID}`} target="_blank">
      pdf
    </a>
    , with no changes made other than format. Please cite their work
    {paper.license?.url ? (
      <>
        , which is licensed under{" "}
        <Box
          component="a"
          textTransform="capitalize"
          href={paper.license?.url}
          target="_blank"
        >
          {paper.license?.name}
        </Box>
      </>
    ) : null}
  </Typography>
);
